export const SHOPPING_ORIGIN = 'https://shopping.rateit3.de';
export const MAIN_APP_ORIGIN = 'https://vue2204.rateit3.de';
export const INT_SHOPPING_ORIGIN = 'https://intshopping.rateit3.de';
const intMainAppOrigin = process.env.VUE_APP_INT_MAIN_APP_ORIGIN || '';

export function getMainAppOrigin(hostname = typeof window === 'undefined' ? '' : window.location.hostname) {
  if (hostname === 'intshopping.rateit3.de') return intMainAppOrigin;
  return MAIN_APP_ORIGIN;
}

export function getShoppingOrigin(hostname = typeof window === 'undefined' ? '' : window.location.hostname) {
  if (hostname === 'vue2204.rateit3.de' || hostname === 'shopping.rateit3.de') return SHOPPING_ORIGIN;
  return hostname === 'intshopping.rateit3.de' || (intMainAppOrigin && hostname === new URL(intMainAppOrigin).hostname)
    ? INT_SHOPPING_ORIGIN : SHOPPING_ORIGIN;
}

export function isMainAppHost(hostname = typeof window === 'undefined' ? '' : window.location.hostname) {
  return isMainProductionHost(hostname) || !!(intMainAppOrigin && hostname === new URL(intMainAppOrigin).hostname);
}

export function isShoppingHost(hostname = typeof window === 'undefined' ? '' : window.location.hostname) {
  return hostname === 'shopping.rateit3.de' || hostname === 'intshopping.rateit3.de' || hostname === 'shopping.localhost';
}

export function isMainProductionHost(hostname = typeof window === 'undefined' ? '' : window.location.hostname) {
  return hostname === 'vue2204.rateit3.de';
}
